/* eslint-disable no-else-return */

'use client';

import { useRouter } from 'next/navigation';
import { safePromise } from '@funkey/shared';
import { StepNavigationMenu } from '~/features/layout/Steps/client';
import useNotifications from '~/features/notifications/useNotifications';
import { useI18n } from '~/features/i18n';
import { processGraphqlFormErrors } from '~/utils/errors';
import type Layout from './layout';
import { usePartnerRegistrationCtx } from './context';
export default function __Layout(props: React.ComponentProps<typeof Layout>) {
  const ctx = usePartnerRegistrationCtx();
  const i18n = useI18n();
  const router = useRouter();
  const {
    dispatchSuccess
  } = useNotifications();
  return <>
            {props.children}
            <StepNavigationMenu<(typeof Layout.$STEPS)[number]> onStepChange={async () => ctx.formState.validate()} completeButtonLabel={i18n._('Submit registration')} onComplete={async () => {
      const valid = ctx.formState.validate();
      if (!valid) return;
      const response = await safePromise(ctx.registerMutation.mutateAsync({
        input: ctx.getAllStepsValues()
      }));
      if (response.ok) {
        dispatchSuccess({
          message: i18n._(`Partner registartion successful! Check your inbox in a few minutes`)
        });
        router.push(`/login`);
      } else {
        ctx.formState.updateErrors(processGraphqlFormErrors(response.error));
      }
    }} />
        </>;
}